import { ECardPermissionsOptions } from 'constants/graphqlTypes';

export const checkIsAdmin = (permissions?: ECardPermissionsOptions[] | null): boolean =>
  !!permissions?.find((item) => item === ECardPermissionsOptions.RemovePickFully);
